<template>
  <el-dialog :visible="visible" @update:visible="handleClose" class="prodModel" :show-close="false">
    <div class="prodModel-title">
      <div class="prodModel-title-text">{{ title }}</div>
      <img class="prodModel-title-icon" src="https://img.i2soft.net/i2official-web/v2/assets/images/joinus/close.png"
        alt="Close" @click="handleClose" />
    </div>
    <div class="prodModel-content">
      <div v-if="type === 'quantum' && quantumInfo" class="prodModel-content-quantum">
          <p>XL2102 服务器密码机主要提供数据加解密、数字签名/验签、数据完整性鉴别、随机数生成 、密钥管理等密码服务。</p>
          <p>产品支持SM1、SM2、SM3、SM4、SM9算法，是遵循国家密码管理局牵头编制的GM/T 0018《密码设备应用接口规范》、GM/T 0028《密码模块安全技术要求》和GM/T
            0030《服务器密码机技术规范》研制。</p>
          <p>该产品作为我公司推出的遵循国家密码管理局相关标准的通用服务类安可产品,可应用于电信、社保、电力、海关、金融等商用密码通用应用领域。</p>
          <div class="table">
            <table>
              <thead>
                <tr>
                  <th>算法名称</th>
                  <th>性能指标</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(tb_item, tb_index) in quantumInfo.table" :key="`quantum-table-${tb_index}`">
                  <th>{{ (tb_item && tb_item.name) || '--' }}</th>
                  <th class="table-item-target">{{ (tb_item && tb_item.target) || '--' }}</th>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="design">
            <div class="design-left">
              <ul>
                <li v-for="(des_item, des_index) in quantumInfo.powerDesignArr" :key="`quantum-design-${des_index}`">{{ des_item }}</li>
              </ul>
            </div>
            <div class="design-right">
              <img src="https://img.i2soft.net/i2official-web/v2/assets/images/product/sec_prod_quantum_design.png"
                alt="艾融软件-量子加密机电源设计" />
            </div>
          </div>
          <div class="certificate">
            <img class="prodImage"
              src="https://img.i2soft.net/i2official-web/v2/assets/images/product/sec_prod_quantum_cert1.png"
              alt="艾融软件-商用密码产品认证证书" />
            <img class="prodImage"
              src="https://img.i2soft.net/i2official-web/v2/assets/images/product/sec_prod_quantum_cert2.png"
              alt="艾融软件-商用密码产品认证证书" />
            <img class="prodImage"
              src="https://img.i2soft.net/i2official-web/v2/assets/images/product/sec_prod_quantum_cert3.png"
              alt="艾融软件-商用密码产品认证证书" />
          </div>
        </div>
      <div v-else-if="type === 'ai'" class="prodModel-content-ai">
          <div class="title">
            <div>基于国产信创服务器和国产大模型艾融推出</div>
            <div>AI生物识别反诈一体机</div>
          </div>
          <div class="info">
            <div>AI生物识别反诈一体机，是艾融软件2025年2月14日基于资深跨大模型应用和生物识别能力，生物识别反欺诈一体机产品。</div>
            <div>产品名称：
              <span class="text-bold">I2safeAI生物识别金融反欺诈一体机</span>
            </div>
            <div>
              <span>主要特点：</span>
              <ul>
                <li>采用国产信创硬件服务器和操作系统，搭载包括千问、DeepSeek V3 和 R1
                  模型多个国产大模型，充分利用各个大模型在文本数据和图像数据智能化处理上的差异化优势，结合艾融金融反欺诈和生物识别领域的专业技术积累，是新一代生物识别反欺诈大模型应用产品。</li>
                <li>
                  "国产化硬件-国产化大模型算法-金融行业生物识别反欺诈场景应用"深度整合，软硬一体的大模型应用产品，实现端到端行业AI应用交付。产品内置了多模态大模型在AI人脸欺诈场景化专用训练数据集的识别推理和训练迭代能力，可以减少重复集成，实现即插即用快速部署，减少综合使用成本。
                </li>
                <li> 可提供标准化产品+100%客户化现场开发的服务体系，在后续运营期间，为客户提供模型微调、新的大模型引入、专用场景数据集训练迭代优化等一系列增值服务，为客户应用大模型提升智能化能力提供最贴心的保障。
                </li>
              </ul>
            </div>
            <div>
              <span>亮点：</span>
              <ul>
                <li>
                  <span class="text-bold">自主可控：</span>
                  <span>硬件CPU处理器及操作系统、算力芯片、人工智能大模型基础软件全部使用国产化产品，全面自主可控。 </span>
                </li>
                <li>
                  <span class="text-bold">多个大模型应用适配：</span>
                  <span>适配和应用了多个文本大模型和视觉大模型，包括千问、DeepSeek V3 和 R1 模型。</span>
                </li>
                <li>
                  <span class="text-bold"> 视觉大模型和文本大模型融合应用：</span>
                  <span>不依赖单一厂家大模型，选用图像识别结构化效果最佳的视觉大模型和交易文本数据特征提取最佳文本大模型，综合图像和文本数据构建最优的多模态欺诈特征识别大模型应用。</span>
                </li>
                <li>
                  <span class="text-bold"> 基于大模型精准识别人像欺诈行为：</span>
                  <span>大模型通过人脸外貌多维度特征识别大数据分析，结合交易行为大数据分析，更精准的阻断AI伪造人像欺诈交易，解决现有生物识别系统活体检测和人脸比对算法安全性和准确性不足，易被攻击骗过的风险。</span>
                </li>
                <li>
                  <span class="text-bold"> 内置对接权威AI人脸欺诈情报：</span>
                  <span>通过公安部身份核验系统的AI人脸欺诈情报数据支持，可实时阻断情报命中的可疑交易，人脸欺诈交易识别更准确灵敏。</span>
                </li>
                <li>
                  <span class="text-bold">快速部署：</span>
                  <span>一体化交付硬件、大模型和预训练生物识别反欺诈应用模型，实现快速低成本交付。</span>
                </li>
              </ul>

            </div>
          </div>
        </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ProductDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '产品介绍',
    },
    type: {
      type: String,
      required: true,
    },
    quantumInfo: {
        type: Object,
        default: null
    },
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="less" scoped>
.prodModel {
    /deep/ .el-dialog {
      width: 80%;
      max-height: 80vh;
      display: flex;
      flex-direction: column;
    }

    /deep/ .el-dialog__body {
      padding: 0;
      overflow-y: auto;
      flex-grow: 1;
    }

    /deep/ .el-dialog__header {
      display: none;
    }

    .prodModel-title {
      background: url('https://img.i2soft.net/i2official-web/v2/assets/images/product/prod_modelBack.png') no-repeat;
      background-size: 100% 100%;
      padding: 50px 40px;
      color: #fff;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      flex-shrink: 0;

      .prodModel-title-text {
        font-size: 30px;
        font-weight: 600;
        line-height: 36px;
        letter-spacing: 0px;
        color: #FFFFFF;

        span {
          color: #fff;
        }
      }

      .prodModel-title-icon {
        width: 40px;
        height: 40px;
        cursor: pointer;
      }
    }

    .prodModel-content {
      padding: 40px;

      .prodModel-content-quantum {
        display: flex;
        flex-direction: column;
        row-gap: 20px;
        font-size: 16px;
        line-height: 1.6;
        letter-spacing: 0px;
        color: #1A1A1A;

        p {
          text-align: left;
          text-indent: 2rem;
          margin: 0;
        }

        .table {
          table {
            width: 100%;
            border-collapse: collapse;
            border-width: 1px 0px 0px 1px;
            border-style: solid;
            border-color: #C2C2C2;

            thead {
              background-color: #F3D8B8;
              color: #1A1A1A;
            }

            tr {
              box-sizing: border-box;
            }

            th, td {
              text-align: left;
              padding: 12px 10px;
              border-width: 0px 1px 1px 0px;
              border-style: solid;
              border-color: #C2C2C2;
              vertical-align: middle;
            }

            tbody {
              th, td {
                 font-weight: normal;
              }

              .table-item-target {
                font-weight: bold;
              }
            }
          }
        }

        .design {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          column-gap: 20px;
          flex-wrap: wrap;

          .design-left {
            font-size: 16px;
            font-weight: normal;
            line-height: 2;
            letter-spacing: 0px;
            color: #333333;
            flex: 1;
            min-width: 300px;

            ul {
              list-style-type: disc;
              padding-left: 20px;
              li {
                text-align: left;
                margin-bottom: 10px;
              }
            }
          }

          .design-right {
            flex-shrink: 0;
            img {
              width: 100%;
              max-width: 422px;
              height: auto;
              display: block;
            }
          }
        }

        .certificate {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 20px;
          justify-items: center;
          align-items: center;

          img {
             width: 100%;
             max-width: 340px;
             height: auto;
          }
        }
      }

      .prodModel-content-ai {
        .title {
          text-align: center;
          margin-bottom: 60px;

          div:first-child {
            font-size: 24px;
            font-weight: 500;
            line-height: 1.5;
            text-align: center;
            letter-spacing: 0px;
            color: #333333;
            margin-bottom: 10px;
          }

          div:last-child {
            font-size: 40px;
            font-weight: bold;
            line-height: 1.2;
            text-align: center;
            letter-spacing: 0px;
            color: #B08D57;
          }
        }

        .info {
          display: flex;
          flex-direction: column;
          row-gap: 30px;
          font-size: 16px;
          line-height: 1.6;
          letter-spacing: 0px;
          color: #1A1A1A;

          .text-bold {
            font-weight: 600;
          }

          p {
            text-align: left;
            margin: 0;
            text-indent: 2rem;
          }

          div {
            text-align: left;
          }

          ul {
            list-style-type: disc;
            padding-left: 40px;
            margin: 10px 0;

            li {
              text-align: left;
              padding: 6px 0;
              line-height: 1.8;
            }
          }
        }
      }
    }
  }

</style> 
